import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useState, useRef, Fragment, useEffect } from "react";
import DragUpload from "../chatAiComponents/DragUpload";
import { DebounceInput } from "react-debounce-input";
import { useDispatch, useSelector } from "react-redux";
import { addText, fetchTextListing, textDelete, editText } from "../../redux/actions/chatAiActions";

import Loading from "../assetLibComponents/Loading";
// import CompLoading from "../chatAiComponents/Loading";
import * as types from "../../constants/ChatAiActionTypes";
import Toast from "../assetLibComponents/shared/Toast";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import ChatbotViewer from "./ChatbotViewer";
import { Dialog, Transition, Menu } from '@headlessui/react'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'

import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Mixpanel } from "../../Mixpanel";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ChatText = (props) => {
  
  const dispatch = useDispatch();
  const textareaRef = useRef(null);
  const textListingRef = useRef();
  const cancelButtonRef = useRef();
  const [textValue, setTextValue] = useState("");
  const [searchValue2, setSearchValue2] = useState("");
  const [textDetail, setTextDetail] = useState({});
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [paginatedData, setPaginatedData] = useState([]);
  const [show, setShow] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [counter, setCounter] = useState(1);
  const api_call_hider = useSelector((state) => state.chatAi.apiCallHider);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState({});
  const [uploadedData, setUploadedData] = useState("");
  const textListing = useSelector((state) => state.chatAi.textListing);
  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false)
  const isLoading = useSelector((state) => state.chatAi.loading);
  const total_page = Math.ceil(textListing?.list?.total_count / 10);
  
  const handleClose = () => {
    setEditModal(false);
    setViewModal(false);
    setTextValue("");
    setShow(false);
  }
  const handleShow = () => {
    setShow(true)
  };

  // const handleUpload = (e) => {
  //   // const string = e;
  //   // const pathParts = string?.split('\\');
  //   // const fileName = pathParts[pathParts.length - 1];
  //   setUploadedData(e.target.files[0]?.name);
  //   const files = e.target.files;
  //   const file = files[0];
  //   getBase64(file);
  // };

  const handleEditText = (e) => {
    setCounter(1);
    dispatch(editText(props.authToken,textValue,textDetail));
    setTextValue("");
    handleClose();
  };
  
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (textareaRef.current && textValue.length === 1) {
  //         const len = textareaRef.current.value.length;
  //         textareaRef.current.setSelectionRange(len, len);
  //     }
  //   }, 100);
  // }, [textValue])
  
  
  const handleAddText = (e) => {
    if(textValue?.length > 0 ){
      Mixpanel.track('Created a text');
      setCounter(1);
      dispatch(addText(props.authToken,textValue));
      setTextValue("");
      handleClose();
    }else{
      Toast("Enter Text", "E");
  }
  };
  const handleSearch = (e) => {
    setTextValue(e.target.value);
    handleShow();
  };
  const handleRemoveSearch2 = (e) => {
    setCounter(1);
    setSearchValue2("");
    dispatch(fetchTextListing(props.authToken,"",counter, ""));
  };
  const handleSearch2 = (e) => {
    if (e.target.value !== undefined) {
      setCounter(1);
      setSearchValue2(e.target.value);
      dispatch(fetchTextListing(props.authToken, e.target.value, counter, ""));
    }
  };

  // const getBase64 = file => {
  //   let reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     onLoad(reader.result);
  //   };
  // };
  
  const handleDelete = (id,type) => {
    // dispatch(fetchCrawlUrl(props.authToken, url));
    setDeleteModal(true)
    setDeleteId({id:id,type:type})
  };
  
  useEffect(() => {
    textListingRef.current.addEventListener('scroll', handleScroll);
    return () => {
      if (textListingRef?.current) {
        textListingRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  
  const handleScroll = async () => {
    const { scrollTop, clientHeight, scrollHeight } = textListingRef.current;
    if (scrollTop + clientHeight >= scrollHeight-1) {
      setCounter((prevPage) => prevPage + 1);
    }
  };
  
  const handleEditModal = (key) => {
    setTextValue(key.text);
    setTextDetail(key);
    handleShow();
    setEditModal(true);
    setTimeout(() => {
      if (textareaRef.current) {
          const len = textareaRef.current.value.length;
          textareaRef.current.setSelectionRange(len, len);
      }
    }, 100);
  }
  
  const textDisplay = (text) => {
    return text;
  }
  
  const handleViewer = (key) => {
    setTextValue(key.text);
    handleShow();
    setViewModal(true);
  }
  
  useEffect(() => {
    if (counter > 1) {
      setPaginatedData((prevData) => [...paginatedData, ...textListing?.list?.trained_txt]);
    } else {
      setPaginatedData(textListing?.list?.trained_txt);
    }
  }, [textListing]);
  
  useEffect(() => {
    if (counter <= total_page && counter !== 1) {
      callPaginationApi();
    }
  }, [counter])
  
  const callPaginationApi = async () => {
      await dispatch(fetchTextListing(props.authToken, "", counter, api_call_hider));
  }

  const wordCount = (str) => {
    const stringArray = str.split(" ");
    return stringArray.length
  }
  
  const deleteHandleClose = () => {
    setDeleteModal(false)
    setDeleteId({})
  };

  useEffect(() => {
      dispatch(fetchTextListing(props.authToken,"", 1,api_call_hider));
  }, [])
    
  const chatOpenHandle = (value) => {
    setOpen(value);
  }

  return (
    <>
      {(isLoading) && <Loading />}
      <div className="chat-ai-asset chatUrl">
        {/* Heading with Button */}
        <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto">Text</div>
            <button
              onClick={()=>{setOpen(true)}}
              type="button"
              className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
            >
            <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" />
              Test ChatAI
            </button>     
        </div>
        {/* Input Field with Drag and drop */}
        <div className="w-full flex my-6 mx-auto">
          <div className="flex w-full">
          <div className="bg-white p-2 cursor-pointer justify-between px-2 rounded-[6px] w-full" onClick={handleShow}>
          <span className="relative cursor-pointer w-[80%] border-none px-3 py-2 not-italic font-normal text-[16px] leading-6 text-[rgba(33,33,33,0.3)] inputBorder">Start Typing here or Just paste!</span>
          </div>
          </div>
        </div>
        {/* Listing Asset */}
        <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
        {/* Listing Heading With Search */}
        <div className="px-4 py-5 sm:px-6 flex justify-between">
          <div className="text-base leading-6 font-semibold my-auto">
             Added Text
          </div>
          <div className="relative rounded-md shadow-sm my-auto max-sm:w-[50%]">
            <DebounceInput
              value={searchValue2}
              className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
              placeholder="Search"
              minLength={3}
              debounceTimeout={500}
              onChange={handleSearch2}
            />
            <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
              {searchValue2 && searchValue2 !== "" ? (
                  <Icon.X className="h-4 w-4 text-gray-400 pointer" onClick={handleRemoveSearch2} />
                ) : (
                  <Icon.Search className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch2} />
                )}
            </div>
          </div> 
        </div>
        {/* Listing */}
        <div className="divide-y divide-gray-200 xl:h-[48vh] md:h-[45vh] h-[45vh] overflow-y-scroll listing" ref={textListingRef}>
        {paginatedData?.length > 0 && paginatedData.map((item,index) => {
          return (
            <div className={item.editing !== true ? "flex justify-between px-4 sm:px-6 py-5 sm:p-4":"flex justify-between px-4 sm:px-6 py-5 sm:py-[7px]"}>
              <span title={item?.text} className="text-gray-900 text-sm not-italic font-medium w-[65%] max-sm:w-[40%] inline-block overflow-hidden text-ellipsis whitespace-nowrap ml-2.5">{textDisplay(item?.text)}</span>
              
              <div className="w-[35%] max-sm:w-[60%] flex justify-end items-center">
                <span className="inline-flex max-sm:ml-1 capitalize items-center rounded-md bg-gray-100 ml-4 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                  {wordCount(item?.text)} words
                </span>
                <span className="mx-[25px] not-italic flex items-center cursor-pointer font-bold text-[12px] max-sm:mx-2 leading-3 text-[rgba(33,33,33,0.3)]">
                  {item?.date.slice(0,6)}
                </span>
                <Menu as="div" className="relative inline-block text-left">
                  <div>
                    <Menu.Button className="flex items-center rounded-full text-gray-400 focus:drop-shadow-none	focus:shadow-none focus-visible:drop-shadow-none focus-visible:shadow-none hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-white-500 focus:ring-offset-2 focus:ring-offset-white-100">
                      <span className="sr-only">Open options</span>
                      <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 origin-bottom rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(index >= paginatedData?.length-3 && index > 2 ? " bottom-[30px]":"")}>
                      <div className="py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <span
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm cursor-pointer'
                              )}
                               onClick={()=>{handleViewer(item)}}
                            >
                              Preview
                            </span>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <span
                              href="#"
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm cursor-pointer'
                              )}
                              onClick={()=>{handleEditModal(item)}}
                            >
                              Edit
                            </span>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <span
                              href="#"
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm cursor-pointer'
                              )}
                              onClick={()=>{handleDelete(item.id,"trained_txt")}}
                            >
                              Delete
                            </span>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          )
        })}
        {(paginatedData?.length === 0) && (
          <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[10%] font-[bolder] text-center h-full font-add">
            <span className="flex justify-center items-center text-[40px]">
              <Icon.Inbox />
            </span>
            No Data
          </div>
        )}
        </div>
        </div>
        
        {/* Preview modal  */}
        <Transition.Root show={show || editModal !== false} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden max-sm:w-full rounded-lg bg-[#f2f2f2] px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-4 sm:px-4">
                    <div className={""}>
                      {viewModal !== false && <h3 className="not-italic text-center mb-3 font-bold text-2xl leading-[29px] text-[#00000094]">{ "Preview" }</h3>}
                      <div className="d-flex flex-column">
                        <div className="w-full">
                          <textarea
                            ref={textareaRef}
                            value={textValue}
                            placeholder="Start Typing here or Just paste!"
                            className="w-full h-[65vh] border-none inputBorder p-3 resize-none"
                            onChange={handleSearch}
                            disabled={viewModal === true}  
                          />
                        </div>
                        {viewModal !== true &&
                          <button
                            type="button"
                            onClick={editModal !== true ? handleAddText : handleEditText}
                            className="rounded-md w-[20%] max-sm:w-full justify-center bg-[#92929269] px-3.5 mt-[10px] py-2.5 text-sm text-[rgba(33,33,33,0.8)] font-semibold shadow-sm hover:bg-[#b5b5b5]  not-italic text-right ms-auto flex"
                          >
                            {editModal !== true ? "Add Text" : "Update"}
                          </button>
                        }
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        
        {/* Delete Modal   */}
        <Transition.Root show={deleteModal} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={deleteHandleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                        </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            Delete Text
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                               Are you sure that you want to delete this text?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={() => {
                          dispatch(textDelete(props.authToken, deleteId));
                          setCounter(1);
                          deleteHandleClose();
                        }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={() => deleteHandleClose(false)}
                        ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        
        <ChatbotViewer authToken={props.authToken} open={open} chatOpenHandle={chatOpenHandle} autoQuestion="" />
      </div>
    </>
  );
};

export default ChatText;
